<template>
  <div class='df-loading flex-col aic'>
    <img src="../../assets/images/loading.gif" alt="" class="loading-img">
    <p class="loading-tip">加载中...</p>
  </div>
</template>

<script>
export default {
  name: 'DfLoading',
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style scoped lang='less'>
.loading-img {
  width: 180px;
  height: 180px;
}
.loading-tip {
  padding-top: 13px;
  color: #ffffff;
}
</style>
